import sl                   from 'date-fns/locale/sl';
import format               from 'date-fns/format';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import VueEvents            from 'vue-events';

export default {
    components: {
        VueEvents
    },

    data() {
        return {
            css:                      {
                table:              {
                    tableClass:     'table table-responsive table-striped table-hover',
                    ascendingIcon:  'fa fal fa-angle-up',
                    descendingIcon: 'fa fal fa-angle-down',
                    detailRowClass: 'row-details order-details'
                },
                pagination:         {
                    wrapperClass:  'pagination pagination-sm',
                    activeClass:   'active',
                    disabledClass: 'disabled',
                    pageClass:     'page',
                    linkClass:     'link',
                    icons:         {
                        first: 'fa far fa-angle-double-left',
                        prev:  'fa far fa-angle-left',
                        next:  'fa far fa-angle-right',
                        last:  'fa far fa-angle-double-right',
                    },
                },
                dropdownPagination: {
                    wrapperClass:  'dropdown pull-right',
                    activeClass:   'active',
                    disabledClass: 'disabled',
                    pageClass:     'page',
                    linkClass:     'link',
                    dropdownClass: 'dropdown-pagination',
                    icons:         {
                        first: 'btn btn-md btn-default fa far fa-angle-double-left',
                        prev:  'btn btn-md btn-default fa far fa-angle-left',
                        next:  'btn btn-md btn-default fa far fa-angle-right',
                        last:  'btn btn-md btn-default fa far fa-angle-double-right',
                    },
                },
                icons:              {
                    first: 'fa far fa-angle-double-left',
                    prev:  'fa far fa-angle-left',
                    next:  'fa far fa-angle-right',
                    last:  'fa far fa-angle-double-right',
                }
            },
            initialPage:              1,
            perPage:                  8,
            sortOrder:                [{
                field:     'id',
                sortField: 'id',
                direction: 'asc'
            }],
            moreParams:               {},
            filterBy:                 [],
            newItem:                  {},
            paginationWithHistoryUrl: true
        };
    },

    watch: {
        sortOrder(current, previous) {
            this.dataLoading();
        }
    },

    methods: {
        showAddModal() {
            if (this.$root.showModal)
                return;

            this.$set(this.$root, 'showModal', true);
        },

        formatDate(value, fmt = 'D MMM YYYY') {
            return value ? format(value.date, fmt, {locale: sl}) : 'n/a';
        },

        humanDiffDate(value) {
            return value ? distanceInWordsToNow(value.date) : 'n/a';
        },

        addMonthsText(value) {
            return value + (Number(value) === 1 ? ' month' : ' months');
        },

        rowClass(dataItem, index) {
            return dataItem.status ? 'enabled' : 'disabled';
        },

        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);

            if (this.paginationWithHistoryUrl) {
                this.historyUrl(paginationData);
            }
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },

        onCellClicked(data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.id);
        },

        onRowClicked(data, field, event) {
            this.onCellClicked(data, field, event);
        },

        historyUrl(paginationData) {
            window.history.replaceState({}, null, window.location.pathname + '?' + window.queryString.stringify(
                Object.assign({
                    sort:     [this.sortOrder[0].sortField, this.sortOrder[0].direction].join('|'),
                    page:     paginationData.current_page,
                    per_page: paginationData.per_page,
                }, this.moreParams)
            ));
        },

        truncate(str, limit) {
            return str.length > limit ? str.substr(0, limit - 1) + '...' : str;
        },

        searchBarPadding(index) {
            if (index === 0) {
                return 'pr-lg-2';
            } else if (index === this.filterBy.length - 1) {
                return 'pl-lg-2';
            } else {
                return 'pr-lg-2 pl-lg-2';
            }
        },

        resetNewItem() {
            throw 'Not implemented! You must do that yourself!';
        },

        prepareNewItemData() {
            return {};
        },
    },

    events: {
        doFilter(filterBy, filterText = '') {
            if (filterBy) {
                this.$set(this.moreParams, filterBy, filterText);

                Vue.nextTick(() => this.$refs.vuetable.refresh());
            }
        },

        resetFilter(filterBy = null) {
            if (filterBy === null) {
                this.$set(this, 'moreParams', {});
            } else {
                Reflect.deleteProperty(this.moreParams, filterBy);
            }

            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        deleteItem(data, forceReload = false) {
            axios.delete(`${this.api_route}/${data.id}`)
                .then(response => {
                    data.status = false;

                    this.$toast.success({
                        title:   'USPEH!',
                        message: response.data.status
                    });

                    if (forceReload) {
                        Vue.nextTick(() => this.$refs.vuetable.refresh());
                    }
                })
                .catch(error => {
                    this.$toast.error({
                        title:   'NAPAKA!',
                        message: error,
                        timeOut: 10000
                    });
                });
        },

        resurrectItem(data, forceReload = false) {
            axios.post(`${this.api_resurrect_route}`, {id: data.id})
                .then(response => {
                    data.status = true;

                    this.$toast.success({
                        title:   'USPEH!',
                        message: response.data.status
                    });

                    if (forceReload) {
                        Vue.nextTick(() => this.$refs.vuetable.refresh());
                    }
                })
                .catch(error => {
                    this.$toast.error({
                        title:   'NAPAKA!',
                        message: error,
                        timeOut: 10000
                    });
                });
        },

        refreshTableData() {
            Vue.nextTick(() => this.$refs.vuetable.reload());
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Table.js